import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import {
  COMPANY_PROFILE_LIST_LEFT,
  COMPANY_PROFILE_LIST_RIGHT,
  DEFAULT_TIMER,
  DOMAIN_NAMES,
  ERROR_MSG,
  LOCALSTORAGE_KEYS,
  INTEL_CLOUDINARY_BASE_URL,
  EMAIL_ERROR_MESSAGE,
} from "../../utils/enum";
import classes from "./login.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import OtpInput from "react-otp-input";
import { authenticateUserHandler, verifyUserHandler } from "../../service/axios/login.axios";
import { getLocalStorageItemHandler, setLocalStorageItemHandler } from "../../service/local-storage";
import { toast } from "react-toastify";
import { checkValidEmailHandler, useQuery, useTimer } from "../../utils/hooks";
import { emailRegex } from "../../utils/regex";
import { GTM_ENUM } from "../../utils/gtm_enum";

const { proceedBtnEmailPopupAPIex, gobackBtnEmailPopupAPIex, resendOtpPopupAPIex, proceedBtnOtpPopupAPIex, gobackBtnOtpPopupAPIex } = GTM_ENUM;
const Login = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(null);
  const [loader, setLoader] = useState(false);
  const [isAcknowledge, setIsAcknowledge] = useState(false);
  const [emailEncryptKey, setEmailEncryptKey] = useState("");
  const [isEmail, setIsEmail] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpStep, setOtpStep] = useState(1);
  const navigate = useNavigate();
  let query = useQuery("defaultKeyType");
  const internalParam = useQuery("internal");
  const { USER_DATA, USER_TRACK } = LOCALSTORAGE_KEYS;

  // to change from email screen to otp screen
  const submitHandler = () => {
    if (step === 1) {
      submitEmailHandler(isEmail ? "?marketing_campaign=true" : "");
    } else {
      submitOtpHandler();
    }
    setOtpError("");
  };

  useEffect(() => {
    if (internalParam !== "true") {
      window.location.href = "https://trademo.com";
      return;
    }

    let userData = getLocalStorageItemHandler(USER_DATA);
    if (userData && Object.keys(userData)?.length) {
      let parsedUserData = userData;
      if (parsedUserData?.session_id) {
        const urlParams = new URLSearchParams(window.location.search);
        const defaultKeyType = urlParams.get("defaultKeyType");
        if (defaultKeyType) {
          navigate("/api-exploration?defaultKeyType=" + defaultKeyType);
        } else {
          navigate("/api-exploration");
        }
      }
    }
  }, [internalParam]);

  // submit email id authentication
  const submitEmailHandler = (params) => {
    if (emailRegex.test(email) === false) {
      setEmailError(EMAIL_ERROR_MESSAGE);
    } else {
      if (getLocalStorageItemHandler(USER_TRACK)) {
        let obj = getLocalStorageItemHandler(USER_TRACK);
        obj.emailId = email;
        setLocalStorageItemHandler(USER_TRACK, JSON.stringify(obj));
      }
      let emailEncrypt = btoa(email);
      setOtpStep(1);
      let userData = {
        ssoToken: emailEncrypt,
        email: email,
      };
      setLocalStorageItemHandler(USER_DATA, JSON.stringify(userData));
      setLoader(true);
      setTimeout(() => {
        authenticateUserHandler(params)
          .then(({ data }) => {
            setEmailEncryptKey(data.email_key);
            setLoader(false);
            setStep(2);
            toast.success(data.message);
          })
          .catch((err) => {
            setLoader(false);
            if (err?.reponse?.data?.message) {
              setEmailError(err?.reponse?.data?.message);
            } else {
              setEmailError(ERROR_MSG);
            }
          });
      }, 100);
    }
  };

  // submit otp function
  const submitOtpHandler = () => {
    let userData = getLocalStorageItemHandler(USER_DATA);
    const request = {
      email_key: emailEncryptKey,
      verification_otp: +otp,
    };
    if (getLocalStorageItemHandler(USER_TRACK) && getLocalStorageItemHandler(USER_TRACK).path) {
      request.userActivityDetails = getLocalStorageItemHandler(USER_TRACK).path;
    } else {
      request.userActivityDetails = [];
    }
    verifyUserHandler(request)
      .then(({ data }) => {
        setLocalStorageItemHandler(USER_DATA, JSON.stringify({ ...userData, session_id: data.session_id, access_token: data.access_token }));
        toast.success(data.message);
        setTimeout(() => {
          const urlParams = new URLSearchParams(window.location.search);
          const defaultKeyType = urlParams.get("defaultKeyType");
          if (defaultKeyType) {
            navigate("/api-exploration?defaultKeyType=" + defaultKeyType);
          } else {
            navigate("/api-exploration");
          }
        }, 300);
      })
      .catch((err) => {
        setOtpError(err.response.data.message);
        setOtpStep(err.response.data.step);
        if (err.response.data.step === 2) {
          // timeLeft
        }
      });
  };

  // disable submit button for both otp and email
  const isSubmitDisableHandler = () => {
    if (step === 1) {
      if (email) {
        return false;
      }
      return true;
    } else {
      if (otp) {
        return false;
      }
      return true;
    }
  };

  // go back to last screen function
  const goBackHandler = () => {
    if (step === 1) {
      window.location.href = process.env.REACT_APP_API_WEBSITE_URL;
      // navigate()
    } else {
      setStep(1);
      setOtp(null);
    }
  };
  // to set GTM ID Proceed
  const setSubmitIdHandler = () => {
    if (step === 1) {
      return proceedBtnEmailPopupAPIex;
    } else {
      return proceedBtnOtpPopupAPIex;
    }
  };

  // to set GTM ID back
  const goBackIdHandler = () => {
    if (step === 1) {
      return gobackBtnEmailPopupAPIex;
    } else {
      return gobackBtnOtpPopupAPIex;
    }
  };

  return (
    <div>
      <img alt="" className={classes.login_backdrop} src={`${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1691139072/website/API%20Explorer/api_explorer_bg_2x_mvjtzc.jpg`} />
      <Modal show={true} centered onHide={() => console.log()} backdrop="static" keyboard={false} size="lg" className="modal-content-login">
        {step === 1 ? (
          <Modal.Header>
            <Modal.Title>
              <label className="modal_heading">Explore {query ? query : "API"} for Free</label>
            </Modal.Title>
          </Modal.Header>
        ) : (
          ""
        )}
        <Modal.Body>
          {step === 1 ? (
            <LoginForm
              emailError={emailError}
              isEmail={isEmail}
              setIsEmail={setIsEmail}
              setEmail={(val) => {
                setEmail(val);
                setEmailError("");
              }}
              email={email}
              isAcknowledge={isAcknowledge}
              setIsAcknowledge={setIsAcknowledge}
            />
          ) : (
            <OtpForm
              otpError={otpError}
              otpStep={otpStep}
              isEmail={isEmail}
              submitEmailHandler={submitEmailHandler}
              setOtp={(val) => {
                setOtp(val);
                setOtpError("");
              }}
              otp={otp}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button id={goBackIdHandler()} onClick={goBackHandler} className="btn btn-sm secondary_outline_button">
              Go Back
            </button>
            <button id={setSubmitIdHandler()} onClick={submitHandler} disabled={isSubmitDisableHandler() || loader} className="btn btn-sm primary_fill_button ms-4">
              Proceed
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Login;

const LoginForm = ({ setEmail, email, setIsAcknowledge, isAcknowledge, isEmail, setIsEmail, emailError }) => {
  return (
    <div>
      <div className={classes.login_email_container}>
        <div className={classes.login_email_inner_container}>
          <label className={classes.input_label_sign_in}>
            Enter Business Email address<sup>*</sup>
          </label>
          <div className="mt-1">
            <input value={email} onChange={(e) => setEmail(e.target.value)} className={classes.sign_in_input_field} type="email" />
          </div>
          <p className={classes.error_message}>{emailError}</p>
          <p className={`${classes.sign_text} m-0`}>You will receive a one-time password (OTP) verification code on your email address</p>
        </div>
      </div>
      <div className="text-center mt-5">
        <input onChange={(e) => setIsEmail(e.target.checked)} checked={isEmail} className="primary_checkbox mt-1" type="checkbox" />
        <span className={`${classes.email_login_label} ms-4`}>I agree to receive emails for Trademo products and promotions</span>
      </div>
      <div className="d-flex align-items-center justify-content-center mt-2 mb-1">
        {/* <input onChange={(e) => setIsAcknowledge(e.target.checked)} checked={isAcknowledge} className='primary_checkbox' type='checkbox' /> */}
        <span className={`ms-4 label-md-regular ${classes.email_login_label}`}>
          By submitting this form, you agree to the{" "}
          <a className={classes.sign_in_text_color} target="_blank" href="https://www.trademo.com/terms" rel="noreferrer">
            Terms of Use
          </a>{" "}
          and{" "}
          <a className={classes.sign_in_text_color} target="_blank" href="https://www.trademo.com/privacy-policy" rel="noreferrer">
            Privacy Policy
          </a>
        </span>
      </div>
    </div>
  );
};

const OtpForm = ({ setOtp, otp, submitEmailHandler, isEmail, otpStep, otpError }) => {
  const [timeLeft, resetTimer] = useTimer(DEFAULT_TIMER);

  return (
    <div>
      <label className={`d-block text-center ${classes.sign_text} mb-4 mt-5`}>{otpStep === 1 ? "Enter OTP sent on your email address" : ""}</label>
      {otpStep === 1 ? (
        <div className={classes.otp_input_field_container}>
          <OtpInput value={otp} onChange={setOtp} numInputs={6} type="number" renderSeparator={<span className="mx-2"></span>} renderInput={(props) => <input {...props} />} />
        </div>
      ) : (
        <div className={classes.inValid_otp_container}>
          <img src={`${INTEL_CLOUDINARY_BASE_URL}/image/upload/v1690465093/intel/icons/wrong_otp_d4fi9y.png`} />
          <h3>It appears you’re experiencing difficulty with your one time-password (OTP).</h3>
          <p>To continue, kindly request a new OTP to be sent to your business email address</p>
        </div>
      )}
      {otpStep === 1 ? <p className={`${classes.error_message} text-center`}>{otpError}</p> : <></>}
      <div>
        <label className={`${classes.sign_text} ${classes.sign_in_otp_resend_container} d-block text-center mb-3`}>
          <span className="me-1">Facing trouble with the OTP?</span>
          <span
            id={resendOtpPopupAPIex}
            onClick={() => {
              if (!timeLeft) {
                resetTimer();
                submitEmailHandler(`?resend=true${isEmail ? "&marketing_campaign=true" : ""}`);
              }
            }}
            className={timeLeft && otpStep === 1 ? classes.sign_in_otp_disabled : classes.sign_in_otp_resend_text}
          >
            Resend OTP
          </span>
          <span className="ms-1">{timeLeft ? `in 00:${timeLeft < 10 ? "0" + timeLeft : timeLeft}` : ""}</span>
        </label>
      </div>
    </div>
  );
};
